import { Link } from "react-router-dom";

const ReserveButton = () => {
    return (
        <div className="flex justify-content-center align-items-center w-full px-6 mt-4">
            <Link
                to="/login"
                style={{
                    background: "#0d203a",
                    color: "white",
                    border: "none",
                    padding: "1rem 2rem",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    direction: "rtl",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    width: "80%",
                    marginTop: "1rem",
                    textAlign: "center",
                    margin: "auto",

                }}
                onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
                }}
            >
                احجز الآن
                <span style={{ fontSize: "1.2rem" }}>←</span>
            </Link>
        </div>
    );
};

export default ReserveButton;
